<!-- =========================================================================================
  File Name: FrequencyView.vue
  Description: User View page
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->

<template>
	<div id="page-user-view">
		<vs-alert color="danger" :title="$t('Frequency.FrequencyNotFound.Title')" :active.sync="frequency_not_found">
			{{
				$t("Frequency.FrequencyNotFound.Text1") +
				" " +
				$route.params.id +
				" " +
				$t("Frequency.FrequencyNotFound.Text2")
			}}
			<span>
				<span>{{ $t("Check") }} </span>
				<router-link :to="{name: 'app-frequency-list'}" class="text-inherit underline">{{
					$t("Frequency.ListOfFrequencies")
				}}</router-link>
			</span>
		</vs-alert>
		<div id="user-data" v-if="frequencyData">
			<vx-card :title="$t('Information')" class="mb-base">
				<div class="vx-row">
					<div class="vx-col flex-1" id="account-info-col-1">
						<table class="text-center">
							<caption></caption>
							<tr>
								<th class="font-semibold" style="font-size: 14px">
									{{ $t("Routing.Table.Identification") }}
								</th>
								<td>{{ frequencyData.id }}</td>
							</tr>
							<tr>
								<th class="font-semibold" style="font-size: 14px">{{ $t("Routing.Table.Name") }}</th>
								<td>{{ frequencyData.name }}</td>
							</tr>
						</table>
					</div>

					<div class="vx-col flex-1" id="account-info-col-2">
						<table class="text-center">
							<caption></caption>
							<tr>
								<th class="font-semibold" style="font-size: 14px">{{ $t("TimeWindow.Duration") }}</th>
								<td>{{ frequencyData.duration }}</td>
							</tr>
						</table>
					</div>

					<div class="vx-col w-full flex mt-base justify-end" id="account-manage-buttons">
						<vs-button
							type="border"
							icon-pack="feather"
							icon="icon-edit"
							class="mr-4"
							color="success"
							:title="windowWidth > 620 ? null : $t('Crud.Update')"
							:size="iconSize"
							:to="{
								name: 'app-frequency-edit',
								params: {id: $route.params.id},
							}"
							>{{ windowWidth > 620 ? $t("Crud.Update") : null }}
						</vs-button>
						<vs-button
							type="border"
							color="danger"
							icon-pack="feather"
							icon="icon-trash"
							class="mr-4"
							:title="windowWidth > 620 ? null : $t('Crud.Delete')"
							:size="iconSize"
							@click="confirmDeleteRecord"
							>{{ windowWidth > 620 ? $t("Crud.Delete") : null }}
						</vs-button>
						<vs-button
							type="border"
							color="primary"
							icon-pack="feather"
							icon="icon-list"
							:title="windowWidth > 620 ? null : $t('Frequency.ListOfFrequencies')"
							:size="iconSize"
							:to="{name: 'app-frequency-list'}"
							>{{ windowWidth > 620 ? $t("Frequency.ListOfFrequencies") : null }}</vs-button
						>
					</div>
				</div>
				<vs-divider class="mt-base mb-base"></vs-divider>
				<template lang="html">
					<vs-tabs>
						<vs-tab
							:label="$t('TimeWindow.Schedule') | capitalize"
							icon-pack="feather"
							icon="icon-calendar"
							class="mb-base mt-base"
						>
							<time-calendar
								ref="timeCalendar"
								:viewData="true"
								:isMaximize="false"
								:cronExpression="frequencyData.cron"
								:duration="frequencyData.duration ? frequencyData.duration : '12:00:00'"
							/>
						</vs-tab>
						<vs-tab
							:label="$t('VisitPoints.AssignedVisitPoints') | capitalize"
							icon-pack="feather"
							icon="icon-map-pin"
							class="mb-base mt-base"
						>
							<assigned-visit-point-list
								v-if="visitPointIds.length > 0"
								:isDemand="false"
								:isTypeService="false"
								:remove="false"
								:redirect="true"
								:visit_point_ids="visitPointIds"
								:configColumns="false"
							></assigned-visit-point-list>
							<vx-card v-else no-shadow card-border>
								<vs-alert active class="mb-5" color="primary">
									<span> {{ $t("VisitPoints.NoAssignedVisitPoints") }} </span>
								</vs-alert>
							</vx-card>
						</vs-tab>
						<vs-tab
							:label="$t('Vehicles.AssignedVehicles') | capitalize"
							icon-pack="feather"
							icon="icon-users"
							class="mb-base mt-base"
						>
							<vehicle-assigned-list
								v-if="vehicleIds.length > 0"
								:isDemand="false"
								:vehicle_ids="vehicleIds"
								:remove="false"
								:redirect="true"
								:showActions="false"
							></vehicle-assigned-list>
							<vx-card v-else no-shadow card-border>
								<vs-alert active class="mb-5" color="primary">
									<span> {{ $t("Vehicles.NoAssignedVehicles") }} </span>
								</vs-alert>
							</vx-card>
						</vs-tab>
					</vs-tabs>
				</template>
			</vx-card>
		</div>
	</div>
</template>

<script>
import vSelect from "vue-select";
import "swiper/dist/css/swiper.min.css";
import {swiper, swiperSlide} from "vue-awesome-swiper";
import TimeCalendar from "@/components/shared/TimeCalendar.vue";
import VehicleAssignedList from "@/components/vehicle/list/VehicleAssignedList.vue";
import AssignedVisitPointList from "@/components/visit-point/list/AssignedVisitPointList.vue";

export default {
	components: {
		vSelect,
		swiper,
		swiperSlide,
		TimeCalendar,
		VehicleAssignedList,
		AssignedVisitPointList,
	},
	data() {
		return {
			frequencyData: null,
			frequency_not_found: false,
			settings: {
				maxScrollbarLength: 60,
				wheelSpeed: 0.6,
			},
		};
	},
	computed: {
		vehicleIds() {
			return this.frequencyData["vehicle_id"] && this.frequencyData["vehicle_id"] !== null
				? this.frequencyData["vehicle_id"]
				: [];
		},
		visitPointIds() {
			return this.frequencyData["visit_point_id"] && this.frequencyData["visit_point_id"] !== null
				? this.frequencyData["visit_point_id"]
				: [];
		},
		windowWidth() {
			return this.$store.state.windowWidth;
		},
		iconSize() {
			return this.$store.state.windowWidth < 620 ? "small" : "medium";
		},
	},
	methods: {
		openLoading() {
			this.$vs.loading();
		},
		closeLoading() {
			this.$vs.loading.close();
		},
		confirmDeleteRecord() {
			this.$vs.dialog({
				type: "confirm",
				color: "danger",
				title: this.$t("Confirm"),
				text:
					this.$t("Frequency.DeleteFrequency.Text1") +
					` "${this.frequencyData.name}"? ` +
					this.$t("Frequency.DeleteFrequency.Text2"),
				accept: this.deleteRecord,
				acceptText: this.$t("Accept"),
				cancelText: this.$t("Cancel"),
			});
		},
		deleteRecord() {
			this.$store
				.dispatch("frequency/deleteById", this.frequencyData.id)
				.then((res) => {
					this.$router.push({name: "app-frequency-list"});
					this.showDeleteSuccess();
				})
				.catch((err) => {
					console.error(err);
				});
		},
		showDeleteSuccess() {
			this.$vs.notify({
				color: "success",
				title: this.$t("Frequency.CellRenderer.DeleteSuccess.Title"),
				text: this.$t("Frequency.CellRenderer.DeleteSuccess.Text"),
			});
		},
	},
	created() {
		const id = parseInt(this.$route.params.id);
		this.openLoading();
		this.$store
			.dispatch("frequency/frequencyFilter", {id: [id]})
			.then((res) => {
				this.frequencyData = res.records[0];
				this.closeLoading();
				return res.records;
			})
			.catch((err) => {
				this.closeLoading();
				if (err.status === 400) {
					this.frequency_not_found = true;
					return;
				}
				console.error(err);
			});
	},
};
</script>

<style lang="scss">
#avatar-col {
	width: 10rem;
}

#page-user-view {
	table {
		td {
			vertical-align: top;
			min-width: 140px;
			padding-bottom: 0.8rem;
		}

		&:not(.permissions-table) {
			td {
				@media screen and (max-width: 370px) {
					display: block;
				}
			}
		}
	}
}

@media screen and (min-width: 1201px) and (max-width: 1211px),
	only screen and (min-width: 636px) and (max-width: 991px) {
	#account-info-col-1 {
		width: calc(100% - 12rem) !important;
	}
}
.scroll-area {
	margin: auto;
	width: 100%;
	min-height: 400px;
	max-height: 450px;
}
</style>
